module.exports = __webpack_public_path__ + "img/icon_pdf.7d78145d.svg";